import React from "react"
import { connect } from "react-redux"

import { segueToSearch } from "search-new/action-creators"
import { segueToProfile } from "global-action-creators"
import {
    loadUserActions,
    favoriteUserAction,
    unfavoriteUserAction,
    archiveUserAction,
    clearSlice,
} from "shared/favorites/action-creators"

import { favoritesConnection } from "shared/favorites/selectors"

import { UserActionFavoritesAndHistory } from "@/pages/home"

const actions = {
    loadUserActions,
    favoriteUserAction,
    unfavoriteUserAction,
    archiveUserAction,
    clearSlice,
    segueToSearch,
    segueToProfile,
}

export default connect(favoritesConnection, actions)(UserActionFavoritesAndHistory)
